module.exports = __webpack_public_path__ + "static/media/gallery17.08bfebb4.png";